export default "__VITE_ASSET__Bs2736li__"